import { splitCellWithType } from './split-cell-with-type';
import { tableNodeTypes } from './table-node-types';

// Split a selected cell, whose rowpan or colspan is greater than one,
// into smaller cells. Use the first cell type for the new cells.
export var splitCell = function splitCell(state, dispatch) {
  var nodeTypes = tableNodeTypes(state.schema);
  return splitCellWithType(function (_ref) {
    var node = _ref.node;
    return nodeTypes[node.type.spec.tableRole];
  })(state, dispatch);
};